import { useTranslations } from "next-intl";

import { twMerge } from "@/utils/twMerge";

export const BetaDescription = ({ onActionClick }: { onActionClick: () => void }) => {
  const t = useTranslations("sidebar.downloadMenu");
  return (
    <p
      className={twMerge(
        "text-gray-500 text-[15px] leading-[1.2] my-1 px-2 pb-2 whitespace-pre tracking-tight",
        "sm:mt-0 sm:mb-2 sm:whitespace-normal",
      )}
    >
      {t.rich("betaWarning", {
        button: (text) => (
          <button
            type="button"
            className="text-blue-500 text-[15px] hover:underline"
            onClick={onActionClick}
          >
            {text}
          </button>
        ),
      })}
    </p>
  );
};
